import { CommandType } from "~app/common/services/cqs/CommandType";
import { ArbetsorderProduktinstruktionBaseCommand } from "./ArbetsorderProduktinstruktionBaseCommand";
export class AddArbetsorderProduktinstruktionCommand extends ArbetsorderProduktinstruktionBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "AddArbetsorderProduktinstruktionCommand";

    constructor(handelssortimentId: number, produktId: number, arbetsorderId: number, produktinstruktionId: number) {
        super(AddArbetsorderProduktinstruktionCommand.$type, CommandType.Insert);

        this.handelssortimentId = handelssortimentId;
        this.produktId = produktId;
        this.arbetsorderId = arbetsorderId;
        this.produktinstruktionId = produktinstruktionId;
    }
}
